import IpcRouter from '../IpcRouter'
import { MentionableModel } from '@renderer/chat'

export interface ModelIpcRouterType {
  fetchModels: (forceRefresh?: boolean) => Promise<MentionableModel[]>
  removeModel: (modelId: string) => Promise<boolean>
  setDefaultModel: (modelId: string) => Promise<void>
}

class ModelIpcRouter extends IpcRouter<ModelIpcRouterType> {
  constructor() {
    super('model', {
      fetchModels: true,
      removeModel: true,
      setDefaultModel: true,
    })
  }
}

export default ModelIpcRouter
